var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"container d-flex flex-column"},[_c('div',{staticClass:"row vh-100"},[_c('div',{staticClass:"col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }